import clsx from 'clsx'
import { FC, useId } from 'react'

export type RadioButtonProps = React.InputHTMLAttributes<HTMLInputElement> & {
  variant?: 'solid' | 'outline'
  name: string
  value: string | number
  label?: string
}

const RadioButton: FC<RadioButtonProps> = ({ label, variant, ...props }) => {
  const id = useId()

  return (
    <div
      className={clsx('form-check form-check-custom', {
        'form-check-solid': variant === 'solid',
      })}
    >
      <input
        {...props}
        className="form-check-input"
        type="radio"
        id={id}
      />
      <label
        className="form-check-label"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  )
}

export { RadioButton }
